import { render, staticRenderFns } from "./OrderNewsletter.vue?vue&type=template&id=524270f4"
import script from "./OrderNewsletter.vue?vue&type=script&lang=js"
export * from "./OrderNewsletter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports